module.exports = __webpack_public_path__ + "img/logo_emi.d2ac1c46.png";